var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQuestionMark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 2.5C6.48 2.5 2 6.98 2 12.5C2 18.02 6.48 22.5 12 22.5C17.52 22.5 22 18.02 22 12.5C22 6.98 17.52 2.5 12 2.5ZM11 19.5V17.5H13V19.5H11ZM14.17 12.67L15.07 11.75C16.09 10.73 16.44 8.98 15.26 7.35C14.36 6.1 12.91 5.31 11.39 5.55C9.84 5.79 8.59 6.91 8.16 8.38C8 8.94 8.4 9.5 8.98 9.5H9.28C9.67 9.5 9.98 9.22 10.1 8.85C10.43 7.9 11.46 7.27 12.57 7.58C13.27 7.78 13.83 8.39 13.96 9.11C14.09 9.81 13.87 10.47 13.41 10.91L12.17 12.17C11.75 12.59 11.42 13.11 11.22 13.69C11.08 14.1 11 14.54 11 15V15.5H13C13 15.04 13.05 14.68 13.13 14.36C13.31 13.64 13.67 13.18 14.17 12.67Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestionMark);
export default __webpack_public_path__ + "static/media/question-mark.e54278a79b42e90172087743eb2802af.svg";
export { ForwardRef as ReactComponent };